import { cloneObject } from '../../../../utils';
import { getFields } from '../../../../utils/defaultFields';

const fields = [
    'birth',
    'cid',
    'civilState',
    'cpf',
    'dateStartPlan',
    'dn',
    'enrollmentSequence',
    'fullName',
    'gender',
    'stateService',
    'countyService',
    'congenerName',
    'lackGroup',
    'healthPlan',
    'kinshipDegree',
    'motherName',
    'nationality',
    'pis',
    'socialName',
    'sus',
    'weddingDate',
    'height',
    'weight',
];

const schema = {
    ...cloneObject(getFields(fields)),
    countyService: {
        ...cloneObject(getFields(['countyService'])).countyService,
        required: false,
    },
};

schema.documents = [];
schema.fullName.requiredMessage = 'Adicione o nome e sobrenome da pessoa dependente';
schema.motherName.requiredMessage = 'Informe o nome da mãe da pessoa dependente';
schema.weight.requiredMessage = 'Adicione o peso da pessoa dependente';
schema.height.requiredMessage = 'Adicione a altura da pessoa dependente';
schema.enrollmentSequence.help = 'Número da matrícula funcional da pessoa dependente na empresa.';

export default schema;
